import React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import PreparedQuestionCardWrapper from '../PreparedQuestionCardWrapper'
import { type MultiChoiceQuestion } from '../../../types'
import { PreparedEmptyField, StyledFormLabel } from '../../../styles'
import { Box, Checkbox } from '@mui/material'
import { type ISurveySection } from '../../../../../store/slices/SurveyTemplateSlice'

interface MultipleChoiceCardProps {
  question: MultiChoiceQuestion
  questionNumber: number
  index: number
  sectionIndex: number
  totalQuestionInSection: number
  section: ISurveySection
  isEditable?: boolean
  isSurveyTemplate?: boolean
}

const MultiSelectCard: React.FC<MultipleChoiceCardProps> = ({ question, questionNumber, index, sectionIndex, totalQuestionInSection, section, isEditable, isSurveyTemplate }): JSX.Element => {
  const showOptions = (option: string, index: number): JSX.Element | undefined => {
    if (option !== '') {
      return <FormControlLabel key={index} value={option} control={<Checkbox disabled />} label={option} />
    }
  }

  return (
    <PreparedQuestionCardWrapper section={section} questionNumber={questionNumber} question={question} index={index} sectionIndex={sectionIndex} totalQuestionInSection={totalQuestionInSection} isEditable={isEditable} isSurveyTemplate={isSurveyTemplate}>
      <FormControl fullWidth>
        {question?.prompt !== ''
          ? <StyledFormLabel>{question.prompt}</StyledFormLabel>
          : <PreparedEmptyField >Type question...</PreparedEmptyField>
        }
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            mt: 1
          }}
        >
          {question?.object?.map((option: string, index: number) => {
            return showOptions(option, index)
          })}
        </Box>
      </FormControl>
    </PreparedQuestionCardWrapper>
  )
}

export default MultiSelectCard
